import styled from 'styled-components'

import theme from 'styles/theme'
import { rem } from 'polished'

import Slider from 'react-slick'
import { fadeInAnimation } from 'styles/animation'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  &::before {
    background-color: ${theme.colors.sagelight};
    content: '';
    display: block;
    height: 1px;
    margin: 0 auto 0;
    width: 200px;
  }
`

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: hidden;
`

export const StyledSlider = styled(Slider)`
  display: flex;
  flex-direction: row;
  width: 100vw;
  animation: ${fadeInAnimation} 0.2s ease-in-out;
  margin: 0 0 0 0;
  padding: 0;

  .slick-slide {
    ${theme.mediaQueries.medium} {
      transform: translateX(calc(100vw / 4 * -1));
    }
  }
`

export const StepContainer = styled.div`
  width: auto;
  max-width: 780px;
  display: flex !important;
  margin: 0 auto;
`

export const StepSpacer = styled.div`
  max-width: 780px;
  display: none;

  ${theme.mediaQueries.medium} {
    display: block;
  }
`

export const CarouselControlsSpacer = styled.div`
  display: none;
  height: ${rem(80)};

  ${theme.mediaQueries.medium} {
    display: block;
  }
`
